module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/DiscountGallery-ddb7dbc244068d80e30e86b589e2b575.png";